import React from 'react';
import styles from './MessagesList.module.css';
import cn from 'classnames';
import { iconsSources } from '../../helpers/icons';
import Message from '../Message/Message';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { formatPhoneNumber } from '../../helpers/titreHelper';

const MessagesList = ({
  className,
  advtInfo,
  messages,
  setDelay,
  messagesWrapper,
  currentMessageRef,
  phoneNumberFontSize,
  titleFontSize,
  authorFontSize,
  msgFontSize,
  user,
}) => {
  let phoneNumberFormat = formatPhoneNumber(advtInfo?.number, ' ');
  return (
    <div className={cn(styles.wrapper, className)}>
      <div className={styles.container}>
        {(advtInfo.label || phoneNumberFormat || advtInfo.socials) && (
          <div className={styles.info}>
            <div
              className={styles.title}
              style={{ fontSize: `${titleFontSize}rem` }}
            >
              {advtInfo.label}
            </div>
            <div className={styles.desc}>
              <div className={styles.socials}>
                {advtInfo.socials &&
                  advtInfo.socials.map((item) => (
                    <div key={item} className={styles.icon}>
                      <img src={iconsSources[item]} alt={item} />
                    </div>
                  ))}
              </div>
              <div
                className={styles.number}
                style={{ fontSize: `${phoneNumberFontSize}rem` }}
              >
                {phoneNumberFormat}
              </div>
            </div>
          </div>
        )}
        <TransitionGroup className={styles.messages} appear={true}>
          {messages.length > 0 &&
            messages.map((item, i) => (
              <CSSTransition
                key={item.UUID}
                timeout={3000}
                classNames="position"
              >
                <Message
                  key={item.id}
                  message={item.message}
                  titrTag={item.titrTag}
                  setDelay={setDelay}
                  messagesWrapper={messagesWrapper}
                  currentMessageRef={currentMessageRef}
                  authorFontSize={authorFontSize}
                  msgFontSize={msgFontSize}
                  user={user}
                />
              </CSSTransition>
            ))}
        </TransitionGroup>
      </div>
    </div>
  );
};
export default React.memo(MessagesList);
